import React, { Component } from "react";
// @mui/material components
import { styled } from "@mui/material/styles";
import { Box,DialogContent, DialogTitle, Dialog, DialogActions, Fab, Tooltip } from "@mui/material";
import { connect } from 'react-redux';
import InputLabel from "@mui/material/InputLabel";
import {  Formik, Form, Field } from 'formik';
import { TextField } from 'formik-mui';
import * as yup from 'yup';
import axios from 'axios';
// core components
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardAvatar from "../../components/Card/CardAvatar.jsx";
import CardBody from "../../components/Card/CardBody";
import CardFooter from "../../components/Card/CardFooter.jsx";
import Snackbar from '@mui/material/Snackbar';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import FacebookIcon from '@mui/icons-material/Facebook';
import avatar from "/assets/images/no_pic.jpg";
import { baseUrl } from '../../components/shared/baseUrl';
import { logoutUser } from "../../reducers/actionCreators";
import withRouterCompat from "../../actions/routerWrapper";

const StyledcardTitle = styled('div')({
   color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
});

const StyledcardCategory = styled('div')({
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
});



const validationSchema = yup.object().shape({
  
  email: yup
    .string()
    .required("email is required")
    .email(),

  lname: yup
    .string()
    .required("Last name is required")
    .min(2, "Too Short")
    .max(15, "Too Long!"),

  fname: yup
    .string()
    .required("First name is required")
    .min(2, "Too Short")
    .max(15, "Too Long!"),
    
  school:yup
    .string()
    .min(2, "Too Short"),

  area:yup
    .string()
    .min(2, "Too Short"),
  
  place:yup
    .string()
    .min(2, "Too Short")

  
})

const mapDispatchToProps = (dispatch) => ({

  logoutUser:() => dispatch(logoutUser())
  
});

class UserProfile extends Component {
  constructor(props) {
    super(props)
    this.state = {
        edit:false,
        open1:false,
        open:false,
        email:'',
        errors:'',
        currpass:'',
        pass:'',
        repass:'',
        fname:'',
        lname:'',
        school:'',
        area:'',
        place:'',
        about:'',
        userstate:'',
        user:'',
        isLoading:true

    };

    
    this.editbutton=this.editbutton.bind(this);
    this.fetchUser=this.fetchUser.bind(this);
    this.handleClickOpen1 = this.handleClickOpen1.bind(this);
    this.handleClose1 = this.handleClose1.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.onChange = this.onChange.bind(this);
    this.validatePass = this.validatePass.bind(this);
    this.validatePass1 = this.validatePass1.bind(this);
    this.validatePass2 = this.validatePass2.bind(this);
    this.handleChangeSubmit = this.handleChangeSubmit.bind(this);




}

handleLogout(){
  this.props.logoutUser();
  window.location = "/adi"

}


editbutton(){
  this.setState({edit: !this.state.edit})

}


CancelToken = axios.CancelToken;
source = this.CancelToken.source();

abortController = new AbortController();

fetchUser = async () => {

var id = this.props.user.id;
console.log(this.state.userstate)
const config = {
    headers: { Authorization: `Bearer ${this.props.user.token}` }
};
  try{
  let result = await axios.get(`${baseUrl}users/${id}`,
  config,
  {
  cancelToken:this.source.token});
  return result;
  
  }catch (error) {
    if (axios.isCancel(error)) {
      console.log("Request canceled", error.message);
      throw new Error("Cancelled");
    }
  }

};

handleClose = () => {
  this.setState({ open: false });
}

handleClose1() {
  this.setState({
    open1:!this.state.open1
  });
}

onChange = event => {
  this.setState({ [event.target.name]: event.target.value });
}

handleClickOpen1 = (event) => {
  event.preventDefault();
  //console.log('Clicked change password')
  this.setState({
    open1: !this.state.open1
  });
}

validatePass(value) {
  let error;

  const passwordRegex = /(?=.*[0-9])/;
  value = this.state.currpass
  if(value.length==0){
      error = 'Please enter password'
  }
  else if(value.length<5){
        error = 'Password is too short'
     }
  else if(value.length>=20){
      error = 'Password too long'
  }
  return error;
}

validatePass1(value) {
  let error;

  const passwordRegex = /(?=.*[0-9])/;
  value = this.state.pass
  if(value.length==0){
      error = 'Please enter password'
  }
  else if(value.length<5){
        error = 'Password is too short'
     }
  else if(value.length>=20){
      error = 'Password too long'
  }
  return error;
}


validatePass2(value) {
  let error;
  //console.log(value.length);
  let pass1 = this.state.pass 
  value = this.state.repass
  if(value.length==0){
      error = 'Please confirm password'
  }
  else if(value!==pass1){
    error = 'Password must be matched'
  }
  return error;
}

handleChangeSubmit(){

  if(this.state.currpass===''){
    this.setState({
      errors:'Please enter your current password',
    })
  }
  else if(this.state.pass!==this.state.repass){
    this.setState({
      errors:'New passwords must match',
    })
  }
  else if(this.state.pass==='' || this.state.repass ===''){
    this.setState({
      errors:'You must enter New passwords',
    })
  }
  else{

    const config = {
      headers: { Authorization: `Bearer ${this.props.user.token}` }
  };
  const data={
    username:this.state.email,
    oldpassword:this.state.currpass,
    newpassword:this.state.repass,
  } 
  console.log(data)
      let url = `${baseUrl}changepass`;  
      axios.post(url, data, config)
      .then(response => {        
          console.log(response.data)
          if(response.data.err == null){
          this.setState({
            open1:!this.state.open1,
            open: !this.state.open
          })
        }
        else{
          console.log(response.data)
          this.setState({
            errors:response.data.err.message,
          })

        }
      })
      .catch(errors => 
        this.setState({
          errors:'Incorrect old password',
        })
        )

  }
}

componentDidMount = () =>{
  //console.log(this.props.user);
  if (!this.props.user || !this.props.user.token) {
    console.warn("User not yet loaded");
    return;
  }

    this.setState({ userstate: this.props.user }, () => {
    this.fetchUser()
      .then((response) => {
        const data = response.data;
        this.setState({
          email: data.username,
          fname: data.fname,
          lname: data.lname,
          school: data.school,
          area: data.area,
          place: data.mystate,
          about: data.aboutme,
          isLoading: false,
        });
      })
      .catch((error) => {
        console.log("Error fetching user:", error);
      });
  });


  
}



  render(){
    const { classes } = this.props;
// {console.log(this.state.isLoading)}

  return (
    <div>
    {this.state.isLoading!==true ?

      <GridContainer>
        <Snackbar
          anchorOrigin={{ vertical: 'top',
          horizontal: 'center', }}
          open={this.state.open}
          onClose={this.handleClose}
          message="Password successfully changed"
          autoHideDuration={6000}
          //key={vertical}
          />
        <GridItem xs={12} sm={12} md={8}>
          <Card>
            <CardHeader color="primary">
              <StyledcardTitle>
                <h4>Your Profile</h4>
              </StyledcardTitle>
              <StyledcardCategory>
                <p>Complete your profile</p>
              </StyledcardCategory>
            </CardHeader>
          <Formik
           initialValues={{
            email:this.state.email,
            currpass:this.state.currpass,
            pass: this.state.pass,
            repass:this.state.repass,
            fname:this.state.fname,
            lname:this.state.lname,
            school:this.state.school,
            area:this.state.area,
            place:this.state.place,
            about:this.state.about
             }}
             
            {...console.log(this.state.email)}
             
            validationSchema={validationSchema}

            onSubmit={(values, {setSubmitting}) => {

              setTimeout(() => {
              setSubmitting(true);

              this.setState({edit: !this.state.edit})

              //alert(JSON.stringify(values, null, 2));

              const userDetails ={
                //username:values.email,
                fname:values.fname,
                lname:values.lname,
                school:values.school,
                area:values.area,
                mystate:values.place,
                aboutme:values.about
              }
              const config = {
                headers: { Authorization: `Bearer ${this.props.user.token}` }
            };

              axios.put(`${baseUrl}users/${this.props.user.id}`, userDetails, config)
              .then(response => 
                  {
                      console.log(response.data) 
                      this.setState({
                        email:response.data.username,
                        fname:response.data.fname,
                        lname:response.data.lname,
                        school:response.data.school,
                        area:response.data.area,
                        place:response.data.mystate,
                        about:response.data.aboutme,
                    })  
                  });

              setSubmitting(false);
             }, 500);

             }}
            >
          {({submitForm, isSubmitting, touched, errors}) => (
            <Form>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <Box margin={1}>
                    <Field
                      component={TextField}
                      type="text"
                      label="email"
                      name="email"
                      fullWidth= {true} 
                      disabled={true} 
                                   
                    />
                  </Box>
                </GridItem>
                {/* {console.log(this.props.user)} */}
              {this.props.user.gmailId!==''?
              <Tooltip
              arrow
              title="Logged in using Gmail-Click to Logout"
              placement="bottom">
                <Fab
                  onClick={this.handleLogout}
                  variant="extended"
                  href="#"
                  color="default"
                  size="medium"
                  className="ml-3"
                >
                 <MailOutlineIcon /> Logout
                </Fab>
              </Tooltip>
              :null }

            {this.props.user.facebookId!==''?
              <Tooltip
              arrow
              title="Logged in using Facebook-Click to Logout"
              placement="bottom">
                <Fab
                  onClick={this.handleLogout}
                  variant="extended"
                  href="#"
                  color="default"
                  size="medium"
                  className="ml-3"
                >
                 <FacebookIcon /> Logout
                </Fab>
              </Tooltip>
            :null }
                <GridItem xs={12} sm={12} md={4}>
                {this.props.user.facebookId===''&& this.props.user.gmailId===''?

                  <Tooltip
                  arrow
                  title="Click to change password"
                  placement="bottom">
                    <Fab
                      onClick={e => this.handleClickOpen1(e)}
                      variant="extended"
                      href="#"
                      color="default"
                      size="medium"
                      className="ml-3"
                    >
                      Change password
                    </Fab>
                  </Tooltip>:null}
                </GridItem>

               {/* ///////////////////////////////Modal for change password//////////////////////////////// */}
              <GridItem xs={12} sm={12} md={6}>

                <Dialog
                  open={this.state.open1}
                  onClose={this.handleClose1}
                  maxWidth={'xs'}
                  fullWidth={true}
                  aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Change password</DialogTitle>
                  <DialogContent>
                        {this.state.errors}
                    <Box margin={1}>

                      <Field
                        component={TextField}
                        type="password"
                        label="Please enter your current Password"
                        name="currpass"
                        fullWidth= {true}
                        value={this.state.currpass}
                        validate={this.validatePass}
                        onChange={this.onChange}
                      />
                    </Box>
                    <Box margin={1}>

                      <Field
                        component={TextField}
                        type="password"
                        label="Enter your new Password"
                        name="pass"
                        fullWidth= {true}
                        value={this.state.pass}
                        validate={this.validatePass1}
                        onChange={this.onChange}
                      />
                    </Box>

                    <Box margin={1}>
                      <Field
                        component={TextField}
                        type="password"
                        label="Re-enter your new Password"
                        name="repass"
                        id="repass"
                        fullWidth= {true}
                        value={this.state.repass}
                        validate={this.validatePass2}
                        onChange={this.onChange}
                      />
                    </Box>
                  </DialogContent>
                  <DialogActions>
                    <Button
                        color="primary"
                        variant="contained"
                        type="submit"
                        onClick={this.handleChangeSubmit}
                      >
                      Submit
                    </Button>

                    <Button onClick={this.handleClose1} color="primary">
                       Cancel
                    </Button>
                  </DialogActions>
                </Dialog>
              </GridItem> 

              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                <Box margin={1}>
                  <Field
                    label="First Name"
                    component={TextField}
                    id="fname"
                    name="fname"
                    fullWidth= {true} 
                    {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                    
                  />
                  </Box>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                <Box margin={1}>

                <Field
                    label="Last Name"
                    component={TextField}
                    id="lname"
                    name="lname"
                    fullWidth= {true} 
                    {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                  />
                  </Box>
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                <Box margin={1}>

                <Field
                    label="School"
                    component={TextField}
                    id="school"
                    name="school"
                    fullWidth= {true} 
                    {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                   
                  />
                  </Box>
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                <Box margin={1}>
                <Field
                    label="Area"
                    component={TextField}
                    id="area"
                    name="area"
                    fullWidth= {true} 
                    {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                    
                  />
                  </Box>
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                <Box margin={1}>
                <Field
                    label="State"
                    component={TextField}
                    id="place"
                    name="place"
                    fullWidth= {true} 
                    {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                    
                  />
                  </Box>
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <InputLabel style={{ color: "#AAAAAA" }}>About me</InputLabel>
                  <Box margin={1}>
                  <Field
                    component={TextField}
                    multiline
                    label="Write about yourself"
                    id="about"
                    name="about"
                    {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                    fullWidth= {true} 
                    
                    inputProps={
                       {rows:5}
                    }
                  />
                  </Box>
                </GridItem>
              </GridContainer>
            </CardBody>
            <CardFooter>
            {this.state.edit === true ? <Button color="primary" onClick={submitForm} disabled={isSubmitting}>
              Update Profile</Button> :
             <Button color="primary" onClick={this.editbutton}>Edit Profile</Button> }
            </CardFooter>
            </Form>
          )}
          </Formik>
          </Card>
        </GridItem>





        <GridItem xs={12} sm={12} md={4}>
          <Card profile>
            <CardAvatar profile>
              <a href="#" onClick={e => e.preventDefault()}>
                <img src={avatar} alt="..." />
              </a>
            </CardAvatar>
            <CardBody profile>
                 
                  <StyledcardCategory>
                    <h6>{this.props.type}</h6>
                  </StyledcardCategory>
                   <StyledcardTitle>
                    <h4>{this.state.fname} {this.state.lname}</h4>
                  </StyledcardTitle>
                <p>
                  {this.state.about}
              </p>
              {/* <Button color="primary" round>
                Follow
              </Button> */}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>:<>some issue with loading</>}
    </div>
  );
 }
}

const mapStateToProps = (state) => {
  //console.log(state)
  return {
  user: state.user
  }
};
export default (connect(
  mapStateToProps,mapDispatchToProps
)(withRouterCompat(UserProfile)));